export { BaselineComponent } from './baseline.component';
export { Remediate } from './remediate';
export const href =
    'https://learn.microsoft.com/en-us/intune/intune-service/protect/compliance-policy-create-android-for-work';
